import stringify from 'fast-json-stable-stringify';
import { queryClient } from '../../page/ReactQueryProvider';
import { Params } from '../../types';
import { contextClient } from '../context.client';

export const getMarketContext = async (url: string, params: Params) => {
  return await queryClient.fetchQuery({
    queryKey: ['market-context', url, stringify(params)],
    queryFn: () => {
      return contextClient.getContextSettingOptions(url, params);
    },
    staleTime: Infinity,
  });
};
